export default __webpack_public_path__ + "static/media/image_loader.545679fc.gif";